import {Component, ComponentFactoryResolver, Input, OnInit, ViewChild} from '@angular/core';
import {WarehouseParamsFormDirective} from '../warehouse-params-form.directive';
import {Warehouse} from '../../../warehouse';
import {WarehouseParamsForm} from '../warehouse-params-form';

@Component({
    selector: 'app-warehouse-params-form-selector',
    templateUrl: './warehouse-params-form-selector.component.html',
    styleUrls: ['../../project-form.css']
})
export class WarehouseParamsFormSelectorComponent implements OnInit {
    @ViewChild(WarehouseParamsFormDirective)
    private warehouseParamsForm: WarehouseParamsFormDirective;
    @Input() warehouse: Warehouse;
    // subscription: any;

    constructor(private componentFactoryResolver: ComponentFactoryResolver) {
    }

    ngOnInit() {
        this.loadForm();
    }

    loadForm() {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
            Warehouse.getWarehouseParamsFormComponent(this.warehouse.type));

        const viewContainerRef = this.warehouseParamsForm.viewContainerRef;
        viewContainerRef.clear();

        const componentRef = viewContainerRef.createComponent(componentFactory);
        (<WarehouseParamsForm>componentRef.instance).warehouse = this.warehouse;

    }

}



// WEBPACK FOOTER //
// ./src/app/project/project-form-components/warehouse-params-forms/warehouse-params-form-selector/warehouse-params-form-selector.component.ts